import { Action } from '@ngrx/store';
import { type } from '../../shared';

export const automatiqueShippingActionTypes = {
  ADD: type('[Automatique Shipping DHL] Add'),
  ADD_SUCCESS: type('[Automatique Shipping DHL] Add Success'),
  ADD_FAIL: type('[Automatique Shipping DHL] Add Fail'),
  REMOVE_CLEAR: type('[Automatique Shipping DHL] cleared'),
};

export class CreateAutomatiqueShipping implements Action {
  readonly type = automatiqueShippingActionTypes.ADD;
  // tslint:disable-next-line:no-any
  constructor(public payload?: any) {

  }
}

export class CreateAutomatiqueShippingSuccess implements Action {
  readonly type = automatiqueShippingActionTypes.ADD_SUCCESS;
  // tslint:disable-next-line:no-any
  constructor(public payload?: any) {}
}

export class CreateAutomatiqueShippingFail implements Action {
  readonly type = automatiqueShippingActionTypes.ADD_FAIL;
  constructor(public payload?: string) {}
}

export class ClearAutomatiqueShippingAction implements Action {
  readonly type = automatiqueShippingActionTypes.REMOVE_CLEAR;
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  constructor() {}
}
